import { marked } from 'marked';
import DOMPurify from 'dompurify';

export const TranslateStudyUsers = {
  DomainFromDTO({
    id,
    enrollmentTimestamp = [],
    isActive = true,
    isEnrollmentSurveyComplete = false,
    name = '',
  }) {
    return {
      id,
      name,
      enrollmentTimestamp,
      isActive,
      isEnrollmentSurveyComplete,
    };
  },
};

export const TranslateStudies = {
  DomainFromDTO({
    studyId,
    studyName,
    studyDuration,
    studyConsent,
    participantHealthData,
    version = 1,
  }) {
    const consent = DOMPurify.sanitize(marked(studyConsent));
    
    const collectGranularly = participantHealthData?.frequencyInHours === 0 || 
                             participantHealthData?.frequencyInHours === 'Granular';
    
    const processedParticipantHealthData = {
      ...participantHealthData,
      frequencyInHours:1,
      collectGranularly
    };
    
    return {
      idNumber: studyId,
      name: studyName,
      duration: studyDuration,
      consent,
      isActive: true,
      participantHealthData: processedParticipantHealthData,
      version,
    };
  },
};

export const TranslateStudiesClinician = {
  DomainFromDTO({ name, identifier, enrollmentPassword, version = 1, isActive = true }) {
    return {
      name,
      identifier,
      enrollmentPassword,
      isActive,
      version,
    };
  },
};

export const TranslateCollectHealthData = {
  DTOFromDomain({ text = '', value = '', isActive = false }) {
    return {
      label: text,
      value,
      isActive,
    };
  },
};
